
(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			
			const announcementId = $(this).data("announcement-id");
			const announcementSpeed = $(this).data("announcement-speed") * 1000;
			
			const announcementSwiper = new Swiper(
				`.announcement-js-${announcementId}`,
				{
					direction: "vertical",
					slidesPerView: 1,
					speed: 600,
					initialSlide: 0,
					loop: true,
					allowTouchMove: true,
					autoplay: {
						delay: announcementSpeed,
						disableOnInteraction: false,
					},
				}
			);
		});
	};

	announcementSlider();

	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});

	document.addEventListener("visibilitychange", function () {
		if (!document.hidden) {
			announcementSlider();
		}
	});
})();